import { render } from "./ContactPage.vue?vue&type=template&id=0ccf250a&scoped=true"
const script = {}

import "./ContactPage.vue?vue&type=style&index=0&id=0ccf250a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.30_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ccf250a"]])

export default __exports__